import { dispararErroSistema } from "utils/systemError";

// REACT_APP_ID_SISTEMA e obrigatoria em toda chamada autenticada/publica. Ler
// direto de process.env deixa o tipo string | undefined "vazar" pro header
// (Headers.set/axios exigem string) e, se a env var sumir de algum ambiente,
// manda "Id-Sistema: undefined" pro backend em silencio. Aqui falha alto:
// mostra o modal generico e bloqueia a chamada.
export function getIdSistema(): string {
  const idSistema = process.env.REACT_APP_ID_SISTEMA;

  if (!idSistema) {
    dispararErroSistema(
      "Aplicação não configurada corretamente (Id-Sistema ausente). Procure o suporte técnico.",
    );
  }

  return idSistema;
}
